/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TemplatizeRecipientRequest { 
    recipientTemplateId?: string | null;
    recipientTemplateName?: string | null;
    recipientId?: string | null;
    recipientRoleId?: string | null;
    userEmail?: string | null;
    recipientEnvelopeId?: string | null;
    routingOrder?: number | null;
    isActive?: boolean | null;
    timeStamp?: string | null;
    readonly spolloNullIsValue_RecipientTemplateName?: boolean;
    readonly spolloNullIsValue_RecipientId?: boolean;
    readonly spolloNullIsValue_RecipientRoleId?: boolean;
    readonly spolloNullIsValue_UserEmail?: boolean;
    readonly spolloNullIsValue_RecipientEnvelopeId?: boolean;
    readonly spolloNullIsValue_RoutingOrder?: boolean;
    templatizeDependencies?: boolean;
}

